import { MediaModel } from "app/services/api/types/common/models/MediaModel";
import { DocumentPickerAsset } from "expo-document-picker";

export type ThrelsFileType = DocumentPickerAsset | MediaModel;

export function isDocumentPickerAsset(
  item: ThrelsFileType,
): item is DocumentPickerAsset {
  return item && "uri" in item;
}

export function isMediaModel(item: ThrelsFileType): item is MediaModel {
  return item && "url" in item;
}
